module.exports = __webpack_public_path__ + "static/mediaPlanHero-a385dad0f73324f67bdf067b6bc1d997.png";